module.exports = "/pages/business/foodslabo/charm_image_2.jpg";